import { useForm } from 'react-hook-form';
import NormalButton from './../../../Components/input/normalButton/NormalButton';
import { H1, H4 } from './../../../styles/Common.style';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Form, Row } from 'react-bootstrap';
import { useRef, useState } from 'react';
import circleApproved from '../../../assets/icons/circle-approved.svg';

const EmailVerification = ({ setWizardIndex }) => {
    const [verificationCode, setVerificationCode] = useState(false);

    const { register, handleSubmit, formState: { errors } } = useForm({
        defaultValues: {
          email: "",
        },
      });

    const onFormSubmit = () => {
        setVerificationCode(true);
        console.log("email to reset password")
    }

    return(
        <>
            {
            !verificationCode ?
                <Form className="h-100" onSubmit={handleSubmit(onFormSubmit)}>
                    <div>
                        <H1>Email verification</H1>
                        <p className='fs-16 fw-bold mt-5'>Do we have the correct email? </p>
                        <p>Before we can create a profile for you we need to make sure that we have the correct email. </p>
                        <p>Please make sure that you have access to the email.</p>
                    </div>
                    <div>
                    <div className="form-group mb-1 ">
                        <H4 className="primary-text-color">Private email</H4>
                            <div className="position-relative">
                                <input
                                    className="d-block w-100"
                                    type="email"
                                    name="email"
                                    placeholder="Your email address"
                                    {...register("email", {
                                    required: "Email is required.",
                                    pattern: {
                                        value: /^[^@ ]+@[^@ ]+\.[^@ .]{2,}$/,
                                        message: "Email is not valid.",
                                    },
                                    })}
                                />
                                <label className="input-headings">
                                    Email
                                </label>
                            </div>
                        {errors.email ? (
                            <p className="error-msg">{errors.email.message}</p>
                        ) : null
                        }
                        </div>
                    </div>
                    <NormalButton
                        type="submit"
                        className="fw-900"
                        textColor=" white"
                        border="none"
                        backgroundColor="green"
                        padding="9px 18px"
                        borderRadius="6"
                        fontSize="14"
                        fontWeight="600"
                        buttonText="GET VERIFICATION CODE"
                        bstClassName="mt-5 mb-5"
                        />
                        <div className="position-absolute bottom-0 cursor d-flex align-items-center fs-14" onClick={()=> setWizardIndex(0) }>
                            <FontAwesomeIcon className="me-1" icon="fa-regular fa-arrow-left" />
                            <span>Go Back</span>
                        </div>
                </Form>
            :
                <EmailVerificationCode setVerificationCode={setVerificationCode} setWizardIndex={setWizardIndex} />
            }
        </>
    )
}


const EmailVerificationCode = ({ setVerificationCode, setWizardIndex }) => {
    const { register, handleSubmit, reset, setValue, formState: { errors } } = useForm({
        defaultValues: {
          verificationCode: "",
        },
    });

    const [emailSuccess, setEmailSuccess] = useState(null)
    const [otpValues, setOtpValues] = useState(["", "", "", "", "", ""]);

    const otpFieldsRef = useRef([]);

    const handleInput = (index, value) => {
        if (value.length > 1) {
          return;
        }
        const newOtpValues = [...otpValues];
        newOtpValues[index] = value;
        setOtpValues(newOtpValues);
        setValue(`otp${index+1}`, value, { shouldValidate: true })
        if (value.length === 1 && index < otpValues.length - 1) {
          otpFieldsRef.current[index + 1].focus();
        }
    };

    const handleBackspace = (index) => {
        if (otpValues[index] !== "") {
          const newOtpValues = [...otpValues];
          newOtpValues[index] = "";
          setValue(`otp${index+1}`, '', { shouldValidate: true })
          setOtpValues(newOtpValues);
        } else if (index > 0) {
          otpFieldsRef.current[index - 1].focus();
        }
    };

    const onFormSubmit = () => {
        setEmailSuccess(true)
        setOtpValues(["", "", "", "", "", ""])
        reset();
        setWizardIndex(2)
    }

    return(
        <>
        {
        emailSuccess === null ?
        <Form className="h-100" onSubmit={handleSubmit(onFormSubmit)}>
             <div>
                 <H1 className='primary-text-color'>Email verification</H1>
                 <p className='fs-16 fw-bold mt-4 primary-text-color'>Verification code</p>
                 <p className='primary-text-color'>We have send you an email with a six digit verification code.</p>
                 <p className='primary-text-color'>Please fill out the code below to verify your email.</p>
             </div>
             <div>
             <Row>
                 <div className = "primary-text-color px-0">
                 Verification code
                 </div>
                 <Col className = "pb-2 px-0">
                 <div>
                     <div className="profile-otp-container gap-3 flex-wrap px-2 mt-1
                     ">
                         {otpValues.map((value, index) => (
                             <div className="d-flex flex-column" key={index}>
                                 <input
                                     type="number"
                                     maxLength="1"
                                     className="profile-otp-input"
                                     style={{ width: '40px', height: '40px' }}
                                     value={value}
                                     {...register(`otp${index+1}`, {
                                         required: true,
                                     })}
                                     onChange={(e) => handleInput(index, e.target.value)}
                                     onKeyDown={(e) => {
                                     if (e.key === "Backspace") {
                                         handleBackspace(index);
                                     }
                                     }}
                                     ref={(ref) => {
                                     otpFieldsRef.current[index] = ref;
                                     }}
                                 />
                                 <div className="otp-border"></div>
                             </div>
                         ))}
                     </div>
                     {Boolean(Object.keys(errors).length) && (
                             <p className="error-msg">
                             This OTP is required
                             </p>
                     )}
                     <div className="mt-3">
                         <span className="fs-14 me-1">Didn't get a code?</span>
                         <span className="fs-14" style={{ color: '#91AA7B' }}>Resend code</span>
                     </div>
                 </div>
                 </Col>
             </Row>
             </div>
             <NormalButton
                 type="submit"
                 className="fw-900"
                 textColor=" white"
                 border="none"
                 backgroundColor="green"
                 padding="9px 18px"
                 borderRadius="6"
                 fontSize="14"
                 fontWeight="600"
                 buttonText="VERIFY"
                 bstClassName="mt-3 mb-5"
                 />
                 <div className="position-absolute bottom-0 cursor d-flex align-items-center fs-14" onClick={()=> setVerificationCode(false) }>
                     <FontAwesomeIcon className="me-1" icon="fa-regular fa-arrow-left" />
                     <span>Go Back</span>
                 </div>
         </Form>
         : emailSuccess === true ? 
            <EmailVerificationSuccess setWizardIndex={setWizardIndex} />
         : <EmailVerificationDeclined setEmailSuccess={setEmailSuccess} />
        }
        </>
    )
}

const EmailVerificationSuccess = ({ setWizardIndex }) => {
    return(
        <div className = "p-3" style = {{ height: '180px' }}>
        <Row>
          <Col className = "px-0">
          <H1 className='primary-text-color'>Email verification</H1>
          <p   className = "fs-16 fw-bold primary-text-color mt-4">Verification approved</p>
          </Col>
        </Row>
        <Row>
          <Col className = "px-0 mt-3">
          <p   className = "fs-16"> Wuhu, the code was correct.</p>
          <p   className = "fs-16">You are now ready for next step.</p>
          </Col>
        </Row>
        <Row>
            <Col>
                <img className='d-block mx-auto' src={circleApproved} alt='approved' />
            </Col>
        </Row>
        <NormalButton
            type="submit"
            className="fw-900"
            textColor=" white"
            border="none"
            backgroundColor="green"
            padding="9px 20px"
            borderRadius="6"
            fontSize="14"
            fontWeight="600"
            buttonText="NEXT"
            bstClassName="mt-3 mb-5"
            // onClick={()=> setWizardIndex(2)}
        />
      </div>
    )
}

const EmailVerificationDeclined = ({ setEmailSuccess }) => {
    return(
        <div className = "p-3" style = {{ height: '180px' }}>
        <Row>
          <Col className = "px-0">
          <H1 className='primary-text-color'>Email verification</H1>
          <p   className = "fs-16 fw-bold primary-text-color mt-4">Verification declined</p>
          </Col>
        </Row>
        <Row>
          <Col className = "px-0 mt-3">
          <p   className = "fs-16 primary-text-color">Oh no, something went wrong. The verification code was declined.</p>
          <p   className = "fs-16 primary-text-color">Please go back and try again.</p>
          </Col>
        </Row>
        <NormalButton
            type="submit"
            className="fw-900"
            textColor=" white"
            border="none"
            backgroundColor="green"
            padding="9px 20px"
            borderRadius="6"
            fontSize="14"
            fontWeight="600"
            buttonText="GO BACK"
            bstClassName="mt-3 mb-5"
            onClick={()=> setEmailSuccess(null)}
        />
      </div>
    )
}

export default EmailVerification;